


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { BigProductsBlockDto, ProductDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import HeadingBlock from '@/views/cms/simple/HeadingBlock.vue';
import BrowseProduct from '@/views/product/widgets/BrowseProduct.vue';
import { ProductTuple } from '@/stores/search/util';
import ProductGrid from '@/views/product/ProductGrid.vue';

@Component({
  components: {ProductGrid, BrowseProduct, HeadingBlock, CmsLink},
})
export default class BigProductsBlock extends Vue {
  @Prop({required: true})
  public readonly model!: BigProductsBlockDto;

  public currentPageIndex: number = 0;

  public get pageSize(): number {
    if (this.$mq.desktop) {
      return 3;
    } else if (this.$mq.tabletOrMore) {
      return 2;
    } else {
      return 1;
    }
  }

  public get pageCount(): number {
    if (this.pageSize <= 1) {
      return 1;
    } else {
      return Math.ceil(this.model.products.length / this.pageSize);
    }
  }

  public get currentPage(): ProductTuple[] {
    if (this.pageSize <= 1) {
      return this.model.products
        .map((product) => this.toTuple(product));
    }
    const firstProduct = this.currentPageIndex * this.pageSize;
    return this.model.products
      .slice(firstProduct, firstProduct + this.pageSize)
      .map((product) => this.toTuple(product));
  }

  public get hasPreviousPage(): boolean {
    return this.currentPageIndex > 0;
  }

  public get hasNextPage(): boolean {
    return this.currentPageIndex < (this.pageCount - 1);
  }

  public goBack(): void {
    if (this.hasPreviousPage) {
      this.currentPageIndex -= 1;
    }
  }

  public goForwards(): void {
    if (this.hasNextPage) {
      this.currentPageIndex += 1;
    }
  }

  private toTuple(product: ProductDto): ProductTuple {
    const unit = product.units.units.find((u) => u.abbreviation === product.units.defaultUnit)
      ?? product.units.units.find((u) => u.abbreviation === product.units.storageUnit)
      ?? product.units.units[0];
    return {product, unit};
  }
}
